import { TaxonomyItem } from "types/entities/Taxonomy";

import { BrandSource } from "../consts";

// The group a product is listed under: its brand, or its product line for food
export const getProductBrand = (product: TaxonomyItem, source: BrandSource): TaxonomyItem | undefined =>
  product.relations?.[source.brandRelation]?.[0];
